import en from './en.json';
import es from './es.json';
import fr from './fr.json';

export default { en, es, fr };
